import {types} from './actions.js';

const initialState = {
  loading: false,
  secteurs: []
};

export default function reducer(state = initialState, action) {
  if (action.type === types.START_LOADING) {
    return {
      ...state,
      loading: true
    };
  } else if (action.type === types.STOP_LOADING) {
    return {
      ...state,
      loading: false
    };
  } else if (action.type === types.SET_SECTEURS) {
    return {
      ...state,
      secteurs: action.secteurs,
    }
  }
  return state;
}